import React from 'react'
import { XCircleIcon } from '@heroicons/react/24/solid'
import EtUpdateUserReflectionComp from '@/features/userReflections/EtUpdateUserReflectionComp'

const EtModalUpdateUserReflection = ({ 
  showModal = false, 
  onClose = () => {}, 
  refetchUserReflectionsAll = () => {},
  refetchUserReflections = null,   // FUTURE USE
  defaultTrailId = '', 
  defaultSessionId = '',
  atomicRecord = null,
  allUsers=[], // 06 Feb 2026
  canSyncGoogleDoc = false, // 31 Aug 2026
}) => {

    // First Created: 04 Dec 2025  
    // Author: Atul Pandey  
    // Purpose: Modal wrapper for updating a user reflection
    // Updated - 06 Feb 2026 - added allUsers prop to support sharedWith feature
    // Updated - 31 Aug 2026 - added canSyncGoogleDoc 

    // console.log('allUsers in EtUpdateUserReflectionComp MODAL:', allUsers)
  
    if (!showModal) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-start font-poppins overflow-y-auto p-4" style={{ zIndex: 9999 }}>
      <div className="bg-black p-3 rounded-lg shadow-lg shadow-black relative w-full max-w-5xl">
        
        {/* Close Button */}
        <div
            className="absolute top-1 right-1 m-1 font-bold rounded-full cursor-pointer h-7 w-7 flex justify-center items-center"
            onClick={onClose}
        >
            <XCircleIcon className='text-orange-600 rounded-full hover:text-red-600 h-7 w-7' />
        </div>

        {/* Update Form Component */}
        <EtUpdateUserReflectionComp 
          atomicRecord={atomicRecord}
          onClose={onClose} 
          refetchUserReflections={refetchUserReflections} 
          refetchUserReflectionsAll={refetchUserReflectionsAll} 
          defaultTrailId={defaultTrailId}        
          defaultSessionId={defaultSessionId}
          allUsers={allUsers} // 06 Feb 2026    
          canSyncGoogleDoc={canSyncGoogleDoc} // 31 Aug 2026
        />

      </div>
    </div>
  )
}

export default EtModalUpdateUserReflection
